export enum CursorType {
    Default = 'default',
    Thin = 'thin',
}
